import React, { useState, useContext } from "react"
import { CwvContext } from "../../context/context"

export interface IsState {
  response?: any
  loading: Boolean
  error?: String
}

export interface formData {
  url: string
  device: string
  type: string
}

export function usePerformance() {
  const [state, setState] = useState<IsState | null>({
    response: null,
    loading: false,
    error: null,
  })

  const { setCwvError, cwvDevice, cwvType, cwvError } = useContext(CwvContext)

  async function performanceTest(data: formData) {
    setState({ response: null, loading: true, error: null })
    let a
    let resBody = {}
    data.type == "origin"
      ? (resBody = {
          origin: data.url,
          formFactor: data.device,
        })
      : (resBody = {
          url: data.url,
          formFactor: data.device,
        })

    try {
      await fetch(
        `https://chromeuxreport.googleapis.com/v1/records:queryRecord?key=AIzaSyBoKE99cjC_bM_PBXv2n8l44qFolcYrWZo`,
        {
          method: "POST",
          body: JSON.stringify(resBody),
        }
      )
        .then(response => response.text())
        .then(result => {
          const finalResult = JSON.parse(result)
        

          const webvitalmetric = finalResult?.record

          setCwvError(() => finalResult?.error)

          setState({
            response: {
              data: {
                metric: webvitalmetric?.metrics,
                collectionPeriod: webvitalmetric?.collectionPeriod,
                key: webvitalmetric.key,
                error: finalResult?.error,
              },
            },
            loading: false,
            error: null,
          })

          a = {
            response: {
              data: {
                metric: webvitalmetric?.metrics,
                collectionPeriod: webvitalmetric?.collectionPeriod,
                key: webvitalmetric.key,
                error: finalResult?.error,
              },
            },
            loading: false,
            error: null,
          }
        })
        .catch(err => console.log(err))
    } catch (error) {
      console.error(error)
    }
    return a
  }

  return [performanceTest, state]
}
